{
  "zh-CN": {
    "filteredTable": {
      "actions": {
        "unselect": "Unselect all Selected"
      },
      "labels": {
        "selected": "%{count} 已选择"
      },
      "empty": {
        "info": "我们未找到任何记录。"
      }
    }
  }
}
